/**
 * CHAN-70: textos da aba de webhooks. Funções puras (testadas em labels.test.js).
 */

export const HISTORY_DAYS = 16;
export const HISTORY_NOTICE = `Histórico disponível pelos últimos ${HISTORY_DAYS} dias`;
export const LOAD_ERROR = 'Não foi possível carregar os webhooks. Tente novamente.';

export function emptyMessage(kind) {
  return kind === 'batch'
    ? 'Nenhum webhook foi enviado para este lote'
    : 'Nenhum webhook foi enviado para este envelope';
}

/** pending/sent/failed em português (RN-04). */
export function statusLabel(item) {
  if (!item) return '';
  if (item.status === 'sent') return 'Enviado';
  if (item.status === 'failed') return 'Falha definitiva';
  if (item.status === 'pending') {
    return item.attempts > 0 ? 'Pendente (nova tentativa em breve)' : 'Pendente';
  }
  return item.status;
}

export function statusColor(item) {
  if (item?.status === 'sent') return 'success';
  if (item?.status === 'failed') return 'error';
  return 'warning';
}

/** "3 de 6" */
export function attemptsLabel(item) {
  if (!item) return '';
  return `${item.attempts ?? 0} de ${item.max_attempts ?? 0}`;
}

/** Resultado da última tentativa, legível (RN-05). */
export function resultLabel(item) {
  if (!item || !item.last_result) return 'Nenhuma tentativa ainda';
  switch (item.last_result) {
    case 'http_2xx':
    case 'http_non_2xx':
      return `resposta HTTP ${item.last_status_code}`;
    case 'timeout':
      return 'timeout';
    case 'network_error':
      return 'erro de rede';
    case 'blocked_url':
      return 'URL bloqueada por segurança';
    case 'config_missing':
      return 'configuração de webhook inativa';
    default:
      return item.last_result;
  }
}

export function prettyJson(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      return value;
    }
  }
  return JSON.stringify(value, null, 2);
}

/** Junta páginas sem repetir entrega (RN-08: "carregar mais" sem duplicar). */
export function mergePages(current, incoming) {
  const seen = new Set(current.map((i) => i.outbox_key));
  return current.concat(incoming.filter((i) => !seen.has(i.outbox_key)));
}
